var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F6EDFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_698_1104",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_698_1104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.998C19.8 23.998 19.2083 23.7564 18.725 23.273C18.2417 22.7897 18 22.198 18 21.498C18 20.798 18.2417 20.2064 18.725 19.723C19.2083 19.2397 19.8 18.998 20.5 18.998C21.2 18.998 21.7917 19.2397 22.275 19.723C22.7583 20.2064 23 20.798 23 21.498C23 22.198 22.7583 22.7897 22.275 23.273C21.7917 23.7564 21.2 23.998 20.5 23.998ZM11 27.998C10.45 27.998 9.97917 27.8022 9.5875 27.4105C9.19583 27.0189 9 26.548 9 25.998V11.998C9 11.448 9.19583 10.9772 9.5875 10.5855C9.97917 10.1939 10.45 9.99805 11 9.99805H12V8.99805C12 8.71471 12.0958 8.47721 12.2875 8.28555C12.4792 8.09388 12.7167 7.99805 13 7.99805C13.2833 7.99805 13.5208 8.09388 13.7125 8.28555C13.9042 8.47721 14 8.71471 14 8.99805V9.99805H22V8.99805C22 8.71471 22.0958 8.47721 22.2875 8.28555C22.4792 8.09388 22.7167 7.99805 23 7.99805C23.2833 7.99805 23.5208 8.09388 23.7125 8.28555C23.9042 8.47721 24 8.71471 24 8.99805V9.99805H25C25.55 9.99805 26.0208 10.1939 26.4125 10.5855C26.8042 10.9772 27 11.448 27 11.998V25.998C27 26.548 26.8042 27.0189 26.4125 27.4105C26.0208 27.8022 25.55 27.998 25 27.998H11ZM11 25.998H25V15.998H11V25.998Z",
    fill: "#7D6299"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.24bfcfc65f9a9ea37bb8eb0bc79e2d6a.svg";
export { ForwardRef as ReactComponent };